import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,

  integrations: [
    Sentry.browserTracingIntegration(),
    // Session Replay entra depois, via lazyLoadIntegration — ver abaixo.
  ],

  // Capturar 20% das transações para performance
  tracesSampleRate: parseFloat(
    import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || '0.2',
  ),

  // Session Replay: 10% normal, 100% em erro
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  beforeSend(event) {
    // Não enviar em desenvolvimento local
    if (
      import.meta.env.DEV &&
      !import.meta.env.VITE_SENTRY_FORCE_DEV
    ) {
      return null;
    }
    return event;
  },
});

// O Session Replay é o pedaço mais pesado do SDK e não tem nada a ver com o
// primeiro paint: carrega sob demanda (CDN do Sentry) fora do chunk inicial.
// Falha de carregamento é irrelevante para o usuário — só perdemos o replay.
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.lazyLoadIntegration('replayIntegration')
    .then((replayIntegration) => {
      Sentry.addIntegration(replayIntegration());
    })
    .catch(() => {
      /* sem replay — o resto do Sentry segue funcionando */
    });
}

export default Sentry;
